import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { DatePicker } from './datePicker';
import { FlexContainer } from '../layout/container';
import { getYear, subYears } from 'date-fns';
const reduceYears = (value) => {
    if (!value)
        return null;
    const year = getYear(value);
    if (year > 2099) {
        return subYears(value, year - 2099);
    }
    return value;
};
const normalizeDateRange = ([from, to]) => [
    reduceYears(from),
    reduceYears(to),
];
export const DateRangePicker = ({ onChange, title, fromText = 'von', toText = 'bis', rangeDelimiter = '-', value = [null, null], }) => {
    const [selectedDate, setSelectedDate] = useState(normalizeDateRange(value));
    useEffect(() => {
        setSelectedDate(normalizeDateRange(value));
    }, [...value]);
    const handleChange = (type) => (date) => {
        let copyDate = [...selectedDate];
        if (type === 'from') {
            copyDate = [date, copyDate[1]];
        }
        else {
            copyDate = [copyDate[0], date];
        }
        setSelectedDate(copyDate);
        onChange(copyDate);
    };
    return (_jsxs(FlexContainer, { sx: {
            flexDirection: 'column',
        }, children: [title && (_jsx(Typography, { sx: {
                    mb: 2,
                }, variant: 'h6', children: title })), _jsxs(FlexContainer, { sx: {
                    alignItems: { xs: 'stretch', md: 'center' },
                    flexDirection: { xs: 'column', md: 'row' },
                    gap: { xs: 2, md: 0 },
                }, children: [_jsx(FlexContainer, { sx: { flex: { xs: 'none', md: 1 } }, children: _jsx(DatePicker, { label: fromText, onChange: handleChange('from'), value: selectedDate[0] }) }), _jsx(FlexContainer, { sx: {
                            width: '24px',
                            display: { xs: 'none', md: 'flex' },
                        }, center: true, children: rangeDelimiter }), _jsx(FlexContainer, { sx: { flex: { xs: 'none', md: 1 } }, children: _jsx(DatePicker, { label: toText, onChange: handleChange('to'), value: selectedDate[1] }) })] })] }));
};
